import { render, staticRenderFns } from "./ListSimple2.vue?vue&type=template&id=27fb2362&"
import script from "./ListSimple2.vue?vue&type=script&lang=js&"
export * from "./ListSimple2.vue?vue&type=script&lang=js&"
import style0 from "./ListSimple2.vue?vue&type=style&index=0&id=27fb2362&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports